import type { Depots } from '../types';
import { chantiersSupabase } from './chantiers';
import { comptesSupabase } from './comptes';
import { entreprisesSupabase } from './entreprises';
import { modeleSupabase } from './modele';
import { partenairesSupabase } from './partenaires';
import { relevesSupabase } from './releves';
import { relancesSupabase, savSupabase } from './sav';

/**
 * Les dépôts branchés sur Supabase. Les droits sont ceux de
 * db/002-referentiels.sql et db/003-chantiers.sql.
 */
export const depotsSupabase: Depots = {
  entreprises: entreprisesSupabase,
  partenaires: partenairesSupabase,
  comptes: comptesSupabase,
  chantiers: chantiersSupabase,
  modele: modeleSupabase,
  sav: savSupabase,
  relances: relancesSupabase,
  releves: relevesSupabase,
};
